import React, { useRef } from 'react'

import Slider from '~/components/core/slider'
import Image from '~/components/core/Image'

const SliderMedias = ({ data, isMediaLibrary = false, isProject = false }) => {
  const observed = useRef(null)

  const flickityOptions = {
    cellAlign: 'left',
    contain: true,
    pageDots: true,
    prevNextButtons: false,
    wrapAround: true,
    on: {
      ready: function () {
        if (observed.current !== null) {
          const dots = observed.current.querySelector('.flickity-page-dots')
          const parent = dots.parentNode
          const wrapper = document.createElement('div')
          parent.replaceChild(wrapper, dots)
          wrapper.appendChild(dots)
          wrapper.classList.add('nav-wrapper')
        }
      },
    },
  }

  let checkIfAllMedias = true
  const chapo = data.chapo
    ? data.chapo.chapo
      ? data.chapo.chapo
      : data.chapo
    : null

  data.items.forEach((item) => {
    const alt = item.fields ? item.fields.altImage : item.altImage

    if (alt === undefined) {
      checkIfAllMedias = false
    }
  })

  return (
    <div className="row">
      <div
        className={`col-12 ${isProject ? 'lg-col-6' : 'lg-col-8'} ${isMediaLibrary ? 'mx-auto' : 'lg-col-offset-1'}`}
      >
        <div className="slider-medias">
          {!isMediaLibrary && data.title && (
            <div className="row">
              <div className="col-12 lg-col-6 mx-auto">
                <h2 className="title-block text-blue">{data.title}</h2>
              </div>
            </div>
          )}

          {chapo && (
            <div className="col-12 lg-col-6 mx-auto">
              <p className="paragraph mb-5 lg:mb-10">{chapo}</p>
            </div>
          )}

          <div
            className="relative"
            ref={(el) => {
              observed.current = el
            }}
          >
            {checkIfAllMedias ? (
              <Slider
                flickityOptions={flickityOptions}
                classes="slider-medias__slider"
                navClasses="w-full nav-wrapper"
                iconColor="white"
                // key={`key=${data.items.map((item) => item.id)}`}
              >
                {data.items.map((item, i) => {
                  let legend = item.fields
                    ? item.fields.legend
                    : item.legend
                      ? item.legend.legend
                      : null

                  return (
                    <div className="slider-medias__slide" key={i}>
                      <div className="image-wrapper has-overlay">
                        <Image
                          className="w-full"
                          width="1280"
                          height="560"
                          sizes={{
                            415: [414, 181],
                            767: [767, 335],
                            1023: [963, 421],
                          }}
                          image={item}
                        />
                      </div>

                      {legend && (
                        <div className="row">
                          <div
                            className={`col-12 ${isMediaLibrary ? 'lg-col-8' : 'lg-col-6'} mx-auto`}
                          >
                            <p className="paragraph paragraph--small mt-14 md:mt-5">
                              {legend}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )
                })}
              </Slider>
            ) : (
              'Slider - Format de données incorrect. Il faut uniquement des images si le type médias est sélectionné.'
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SliderMedias
